<div class="main-container">
  <div class="main-container__center-section">
    <div [@opacityGrow]="loaderAnimationState$ | async" (@opacityGrow.start)="$event.element.style.display = 'block'"
         (@opacityGrow.done)="$event.element.style.display = ($event.toState ? 'block' : 'none')">
      <svg class="loader-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43.321 38">
        <path
          d="M52.583,44H30.923l5.446,5.415,5.415,5.415L52.583,44M41.753,65.692h10.83L47.2,60.277H36.369l5.384,5.415M25.507,60.277H21l7.669,7.669,7.7-7.669Z"
          transform="translate(-14.677 -33.138)"
          fill="#ef7c00"
        />
        <path
          d="M57.092,72.162l-5.446-5.415L46.262,61.3,35.4,72.162H57.092m10.8,5.415H57.061l5.415,5.446Z"
          transform="translate(-24.57 -45.023)"
          fill="#dc030e"
        />
        <path
          d="M11.63,84.115,6.215,78.7.8,84.115H11.63Z"
          transform="translate(-0.8 -56.977)"
          fill="#b51b1a"
        />
        <path
          d="M75.484,20.162,80.9,14.746,75.484,9.3,70.1,14.715Z"
          transform="translate(-48.408 -9.3)"
          fill="#fbb900"
        />
      </svg>
      <p>Ładowanie...</p>
    </div>
    <div class="error-info-container" *ngIf="retryInfoVisible$ | async">
      <span class="error-info-container__text"> Przepraszamy – wystąpił błąd.</span>
      <button type="button" class="error-info-container__button" (click)="onRetryClick()"> Spróbuj ponownie</button>
    </div>
  </div>
</div>
<ng-container *ngIf="redirectionUrlLoaded$ | async"></ng-container>

